import { clsfy } from "../../helpers"
const EditorFeatureSubtitle = ({ children, className = '' }) => {
	return (
		<div className={clsfy(className, 'font-bold text-556 lg:text-lg 2xl:text-xl lg:leading-7 2xl:leading-7 lg:mt-5 2xl:mt-7')}>
			{children}
		</div>
	)
}

export default EditorFeatureSubtitle